import { SearchX } from 'lucide-react';
import { ButtonLink } from '../components/ui/button.tsx';
import { Card, EmptyState } from '../components/ui/misc.tsx';

export function NotFoundPage({ what = 'page' }: { what?: string }) {
  return (
    <Card className="mx-auto max-w-lg">
      <EmptyState
        icon={<SearchX className="size-6" />}
        title={`We couldn’t find that ${what}`}
        action={<ButtonLink to="/">Go to the helpdesk home</ButtonLink>}
      >
        It may have been moved, or you may not have access to it.
      </EmptyState>
    </Card>
  );
}
